import type { ChatContactAttributes } from "../types";

/**
 * KMS / data-key API context for decrypting encrypted contact attributes (mdn, firstName, problemStatement).
 *
 * Same rule as before the data-key React Query migration: `dataKeyContext ?? contactId` (not `originalChatId`).
 * Messages use `messageEncryptionContext` separately.
 */
export function contactAttributeEncryptionContext(
    attrs: Pick<ChatContactAttributes, "dataKeyContext">,
    contactId: string,
): string {
    return attrs.dataKeyContext?.value ?? contactId;
}
